/**
 * The assistants a parent can connect from "Connect my LLM". None of them offers a link that fills
 * in a connector address, so the app copies the address and opens the assistant's own page.
 */
export interface AssistantInfo {
  id: "claude" | "chatgpt" | "grok" | "muse";
  name: string;
  company: string;
  /** Where the assistant sends the parent back after consent (exact hostnames). */
  redirectHosts: string[];
  openUrl: string;
  steps: string[];
  /** Plan limits or anything else the parent should know first. */
  note?: string;
}

export const ASSISTANTS: AssistantInfo[] = [
  {
    id: "claude",
    name: "Claude",
    company: "Anthropic",
    redirectHosts: ["claude.ai", "claude.com"],
    openUrl: "https://claude.ai/settings/connectors",
    steps: ["Open Customize → Connectors, then Add → Add custom connector.", "Name it Meaningful Rewards and paste the address.", "Connect, then sign in here and choose what to share."],
  },
  {
    id: "chatgpt",
    name: "ChatGPT",
    company: "OpenAI",
    redirectHosts: ["chatgpt.com"],
    openUrl: "https://chatgpt.com/",
    steps: ["Open Settings → Apps and turn on Developer Mode under Advanced settings.", "Choose Create, name it Meaningful Rewards and paste the address.", "Connect, then sign in here and choose what to share."],
    note: "Needs a paid ChatGPT plan with Developer Mode. Some plans limit what custom apps can do.",
  },
  {
    id: "grok",
    name: "Grok",
    company: "xAI",
    redirectHosts: ["grok.com"],
    openUrl: "https://grok.com/connectors",
    steps: ["Click New Connector, then Custom.", "Paste the address.", "Connect, then sign in here and choose what to share."],
    note: "Early support: we're still testing this connection.",
  },
  {
    id: "muse",
    name: "Muse",
    company: "Meta",
    redirectHosts: ["meta.ai"],
    openUrl: "https://www.meta.ai/",
    steps: ["Ask Muse: “Create a custom connector for a remote MCP server named Meaningful Rewards, using OAuth,” and paste the address.", "Sign in here when it asks, and choose what to share."],
    note: "Early support: we're still testing this connection.",
  },
];

/** The assistant a redirect address really belongs to, whatever name the app registered with. */
export const assistantForHost = (host: string) => ASSISTANTS.find((a) => a.redirectHosts.includes(host)) ?? null;

export const ASSISTANT_REDIRECT_HOSTS = ASSISTANTS.flatMap((a) => a.redirectHosts);

/** What a parent pastes into their assistant to turn on a recurring skill. */
export const WEEKLY_JOBS_REQUEST =
  "Use Meaningful Rewards to set up the weekly job recommendations skill: call get_recurring_skill, then schedule it to run every week if you can, or tell me how.";
